import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import {handleBoxNavigation} from '../../actions/scanpackScanningActions';
import useMultiBoxState from './hooks/useMultiBoxState';
import useWidth from '../scanToCartScanning/useWidth';

const MultiBoxNavBar = () => {
  const windowWidth = useWidth();
  const {
    dispatch,
    multiBox,
    boxes,
    activeBoxIndex,
    handlePrintSlip
  } = useMultiBoxState();

  if (!multiBox || boxes.length === 0 || windowWidth < 900) return null;

  return (
    <LinearGradient
      style={{height: 30, marginBottom: '5%'}}
      start={{x: 0, y: 1}}
      end={{x: 0, y: 0}}
      colors={['#142130', '#304454']}>
      {activeBoxIndex >= 1 && (
        <TouchableOpacity
          style={{flexDirection: 'row', marginTop: '1%'}}
          testID="goPrevIcon"
          onPress={() => dispatch(handleBoxNavigation('prev'))}>
          <i
            className="icon-up-open"
            style={{rotate: '270deg', color: 'white'}}></i>
          <Text style={{color: 'white', fontSize: 18}}>
            Back
          </Text>
        </TouchableOpacity>
      )}

      <TouchableOpacity
        testID="printSlip"
        style={{
          position: 'absolute',
          right: 105,
          marginTop: '1%',
          width: '5%'
        }}
        onPress={handlePrintSlip}>
        <i
          className="icon-print"
          style={{fontSize: 21, color: 'white'}}></i>
      </TouchableOpacity>

      {activeBoxIndex < boxes.length - 1 && (
        <View
          style={{
            position: 'absolute',
            marginTop: '0.5%',
            right: 10
          }}>
          <TouchableOpacity
            style={{flexDirection: 'row', marginTop: '2.5%'}}
            testID="goNextIcon"
            onPress={() => dispatch(handleBoxNavigation('next'))}>
            <Text style={{color: 'white', fontSize: 18}}>
              Next
            </Text>
            <i
              className="icon-up-open"
              style={{rotate: '90deg', color: 'white'}}></i>
          </TouchableOpacity>
        </View>
      )}

      {activeBoxIndex >= boxes.length - 1 && (
        <TouchableOpacity
          testID="addBoxIcon"
          style={{
            position: 'absolute',
            marginTop: '1%',
            left: '90%',
            color: 'white'
          }}
          onPress={() => dispatch(handleBoxNavigation('next'))}>
          <i className="icon-plus" style={{color: 'white'}}></i>
        </TouchableOpacity>
      )}
    </LinearGradient>
  );
};

export default MultiBoxNavBar;
